// Import dependencies
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { gql, useLazyQuery } from '@apollo/client';
import { createBrowserHistory } from 'history';

// Import Image
import Loader from '../../../../web/images/svg/loader.svg';

// Components
import SearchResult from './SearchResult';
import SearchInput from './SearchInput';
// import { InView } from 'react-intersection-observer';

const GET_SEARCH_RESULTS = gql`
  query searchQuery($needle: String!, $limit: Int = null, $offset: Int = 0){
    entries (
      search: $needle,
      limit: $limit,
      offset: $offset,
      hideFromSearchResults: false,
      orderBy: "dateCreated DESC") {
      id,
      title
      url
      type: typeHandle
      ... on pages_richContentPage_Entry {
        teaser: introduction
      }
      ... on pages_landingPage_Entry {
        teaser: introduction
      }
      ... on seasonPackages_seasonPackages_Entry {
        teaser: multilineSynopsis
      }
      ... on concerts_concerts_Entry {
        teaser
        imageListing {
          url @transform (width: 300, immediately: true)
        }
      }
      ... on backstageNews_backstageNews_Entry {
        teaser: description
        date
        imageListing {
          url @transform (width: 300, immediately: true)
        }
      }
      ... on musicians_musicians_Entry {
        imageListing {
          url @transform (width: 300, immediately: true)
        }
      }
    }
    total: entryCount(search: $needle)
  }
`;

let firstSearch = true;

const history = createBrowserHistory();

const Search = ({ limit, offset }) => {
  const needle = new URLSearchParams(window.location.search).get('q') || null;

  const [getResults, {
    loading,
    error,
    data,
    refetch,
    // fetchMore,
  }] = useLazyQuery(GET_SEARCH_RESULTS, {
    variables: {
      limit,
      needle,
      offset,
    },
  });

  let searchFn = getResults;

  if (firstSearch) {
    firstSearch = false;

    if (needle !== null) {
      searchFn({ variables: { needle } });
      searchFn = refetch;
    }
  }

  // todo: infinite scroll
  // const loadMore = useCallback(() => {
  //   fetchMore({
  //     variables: {
  //       offset: data && data.entries ? data.entries.length : 0,
  //     },
  //   });
  // }, [fetchMore, data]);

  if (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    return <div>Error!</div>;
  }
  if (loading) return <div className="c-loader  c-loader--absolute"><Loader /></div>;

  // const inViewThresholdI = limit * 0.75;

  return (
    <>
      <>
        <div className="c-search-listing__subtitle">Refine Search</div>
        <SearchInput history={history} query={needle} searchFn={searchFn} inputId="refine-search-input" />
      </>

      {data && data.entries && (
        <div className="c-search-listing__content">
          <div className="c-search-listing__num-results">
            We found
            {` ${data.entries.length} `}
            results for your query &ldquo;
            {needle}
            &rdquo;
          </div>
          {data.entries.map((entry) => (
            <Fragment key={entry.id}>
              {/* {i % limit === inViewThresholdI && */}
              {/* <InView as="div" onChange={inView => inView && loadMore()} triggerOnce />} */}

              <SearchResult
                key={entry.id}
                title={entry.title}
                teaser={entry.teaser}
                imageListing={entry.imageListing}
                url={entry.url}
                initialLimit={limit}
              />
            </Fragment>
          ))}
        </div>
      )}
    </>
  );
};

Search.propTypes = {
  limit: PropTypes.number,
  offset: PropTypes.number,
};

Search.defaultProps = {
  limit: 80, // todo: pagination
  offset: 0,
};

export default Search;
